import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { name: '首页', path: '/' },
  { name: '作品集', path: '/category/works' },
  { name: '资料档案', path: '/category/profile' },
  { name: '最新动态', path: '/category/news' },
  { name: '粉丝社区', path: '/category/community' },
  { name: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const navbarBg = isHome && !scrolled
    ? 'bg-transparent'
    : 'bg-background-50/95 backdrop-blur-sm';

  const textColor = isHome && !scrolled
    ? 'text-background-50'
    : 'text-foreground-800';

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${navbarBg}`}>
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link to="/" className={`flex items-center gap-2 ${textColor} transition-colors`}>
            <span className="font-heading text-lg md:text-xl font-semibold tracking-wide whitespace-nowrap">
              安斋拉拉主题站
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.path
                || (link.path !== '/' && location.pathname.startsWith(link.path));
              return (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap
                    ${isActive
                      ? isHome && !scrolled
                        ? 'bg-background-50/20 text-background-50'
                        : 'bg-primary-100 text-primary-700'
                      : isHome && !scrolled
                        ? 'text-background-50/80 hover:text-background-50 hover:bg-background-50/10'
                        : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                    }`}
                >
                  {link.name}
                </Link>
              );
            })}
          </div>

          <button
            className={`md:hidden w-9 h-9 flex items-center justify-center rounded-lg ${textColor}`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200 py-2">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.path
                || (link.path !== '/' && location.pathname.startsWith(link.path));
              return (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`block px-4 py-3 text-sm font-medium transition-colors whitespace-nowrap
                    ${isActive
                      ? 'text-primary-600 bg-primary-50'
                      : 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100'
                    }`}
                >
                  {link.name}
                </Link>
              );
            })}
          </div>
        )}
      </div>
    </nav>
  );
}